import {
  Card,
  Heading,
  useFormContext,
} from '@frontendmentorio/design-system-v2';

import RetrospectivePreview from 'features/solutions/RetrospectivePreview';

export default function FormRetrospectivePreview({ solution = {} }) {
  const { getValues } = useFormContext();

  const data = getValues();

  return (
    <Card className="flex flex-col gap-5 p-5">
      <Heading level="5" tagName="h2">
        Solution retrospective preview
      </Heading>

      <p>
        Below is a preview of your formatted retrospective. Edit the fields
        above if you want to tweak your message before submitting. Remember to
        ask specific questions to improve the chances of receiving helpful
        feedback from others.
      </p>

      <div className="bg-gray-100 rounded-lg p-5">
        <RetrospectivePreview solution={{ ...solution, ...data }} />
      </div>
    </Card>
  );
}
